import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const  PRIORITIES_ROUTE = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro de guardar los cambios?',
    valueButton: 'Guardar',
    color: CONFIRM_COLOR.SUCCESS,
    iconSVG: CONFIRM_ICONS.SAVE
  };
